var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"bg-slider__item"},[_c('picture',[_c('source',{attrs:{"srcset":(_vm.link + "webp"),"type":"image/webp"}}),_c('img',{attrs:{"src":(_vm.link + "jpg"),"alt":_vm.title,"type":"image/jpg"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }